import { useState, useMemo } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { useFetchResourcesByIdsQuery } from "@shared/services/queries";
import { ApiResponse } from "@shared/types";
import { AgreementPlan } from "@modules/agreementPlans/types";

export function useAgreementsPlansList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<AgreementPlan>({
    resource: "v1/agreement_plans_admin",
    filters: getQueryParams(),
    sorters: { ordering: "-id" },
  });

  const agreementIds = useMemo(
    () => [...new Set(rows?.map((plan) => plan.for_agreement).filter((id): id is number => !!id))],
    [rows]
  );

  const { data: agreement } = useFetchResourcesByIdsQuery<ApiResponse<AgreementPlan>>({
    resource: "v1/agreement_admin",
    ids: agreementIds,
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    agreement: agreement?.results,
    dataToExport,
    refetch,
    setSelectedRows,
    translate,
  };
}
